import MainContainer from "./components/maincontainer";
function App() {
  return <MainContainer />;
}
export default App;
